import type { TFunction } from 'i18next';
import {
  ITEM_HEALTH_RISK_TYPES,
  type ItemHealthRiskType,
} from '@/common/api/types/dashboard/health';

export const getHealthRiskTypeTitle = (type: ItemHealthRiskType, t: TFunction): string => {
  switch (type) {
    case ITEM_HEALTH_RISK_TYPES.PLANNED_START_DATE_PASSED:
      return t(($) => $.insights.healthAlerts.groupTitles.plannedStartDatePassed);
    case ITEM_HEALTH_RISK_TYPES.PLANNED_FINISH_DATE_PASSED:
      return t(($) => $.insights.healthAlerts.groupTitles.finishDatePassed);
    case ITEM_HEALTH_RISK_TYPES.UNPLANNED_WORK:
      return t(($) => $.insights.healthAlerts.groupTitles.unplannedWork);
    case ITEM_HEALTH_RISK_TYPES.DELTA_DIFF_LARGER_THAN_FIVE_PERCENT:
      return t(($) => $.insights.healthAlerts.groupTitles.deltaDiffFivePercent);
    case ITEM_HEALTH_RISK_TYPES.DELTA_DIFF_LARGER_THAN_ONE_PERCENT:
      return t(($) => $.insights.healthAlerts.groupTitles.deltaDiffOnePercent);
    case ITEM_HEALTH_RISK_TYPES.BLOCKED_BY_DEPENDENCY:
      return t(($) => $.insights.healthAlerts.groupTitles.blockedByDependency);
    default: {
      // Compile-time error if a new ItemHealthRiskType value is added without a case
      const _exhaustiveCheck: never = type;
      return String(_exhaustiveCheck);
    }
  }
};
